import { api, requestHeaders } from '../../../functions/api';
import i18n from '../../../i18n';
import { LanguagesEnum } from '../../../translations/Models/Translations.models';
import { FilesService } from '../../../Utils/Files.service';
import {
    LoadPatientsResponse,
    ValidationLoadPatientsResponse,
} from './interfaces/PatientMassLoadinterfaces';

export class PatientMassLoadService {
    private filesService = new FilesService();
    private currentLanguageString = i18n.language;
    private headers = { ...requestHeaders };
    // private userId = useDataContext().currentUserId;
    private currentLanguageEnum: LanguagesEnum =
        this.currentLanguageString === 'en'
            ? LanguagesEnum.ENGLISH
            : this.currentLanguageString === 'ca'
            ? LanguagesEnum.CATALAN
            : LanguagesEnum.SPANISH; // Por defecto español

    /**
     * Descarga la plantilla de carga masiva de pacientes
     * y la guarda con el nombre según el idioma
     */
    public async downloadTemplateLoadPatients(): Promise<void> {
        const response = await fetch(
            api + `files/downloadtemplateloadpatients/${this.currentLanguageEnum}`,
            {
                method: 'GET',
                headers: this.headers,
                credentials: 'include',
            }
        );
        if (response.status === 200) {
            // Leemos directamente el archivo como Blob
            const blob = await response.blob();

            // Mapear nombres de archivo según idioma
            const fileNames: Record<LanguagesEnum, string> = {
                [LanguagesEnum.ENGLISH]: 'Template_Mass_Patient_Upload.xlsx',
                [LanguagesEnum.SPANISH]: 'Plantilla_Carga_Pacientes_Masiva.xlsx',
                [LanguagesEnum.CATALAN]: 'Plantilla_Carrega_Pacients_Massiva.xlsx',
            };

            const fileName = fileNames[this.currentLanguageEnum] ?? 'Plantilla.xlsx';

            // Descargar el archivo
            this.filesService.downloadFileFromBlob(blob, fileName);
        } else {
            const errorCode = response.headers.get('X-Error-Code') ?? '000';
            throw new Error(`${response.status}/${errorCode}`);
        }
    }

    /**
     * Valida la excel de carga masiva de pacientes enviada por el usuario de tipo cliente
     */
    public async validatePatientsMassUploadExcel(
        selectedFileByUser: File,
        currentUserId: string | null
    ): Promise<ValidationLoadPatientsResponse> {
        const requestBody = new FormData();
        requestBody.append('file', selectedFileByUser);

        const response = await fetch(
            `${api}patients/validatetemplateloadpatients/${currentUserId}/${this.currentLanguageEnum}`,
            {
                method: 'PUT',
                headers: {
                    Accept: '*/*',
                },
                body: requestBody,
                credentials: 'include',
            }
        );

        if (response.status === 200) {
            return response.json();
        } else {
            const errorCode = response.headers.get('X-Error-Code') ?? '000';
            throw new Error(`${response.status}/${errorCode}`);
        }
    }

    /**
     * Importa los pacientes contra la bbdd
     */
    public async loadPatientsMassUploadExcel(
        selectedFileByUser: File,
        currentUserId: string | null
    ): Promise<LoadPatientsResponse> {
        const requestBody = new FormData();
        requestBody.append('file', selectedFileByUser);

        const response = await fetch(
            `${api}patients/uploadtemplateloadpatients/${currentUserId}/${this.currentLanguageEnum}`,
            {
                method: 'PUT',
                headers: {
                    Accept: '*/*',
                },
                body: requestBody,
                credentials: 'include',
            }
        );

        if (response.status === 200) {
            return response.json();
        } else {
            const errorCode = response.headers.get('X-Error-Code') ?? '000';
            throw new Error(`${response.status}/${errorCode}`);
        }
    }
}
